import { Role } from '@nemuru-eng/js-api-client';
import { useAuth } from '@nemuru-eng/providers';

export const useRoles = () => {
  const { user } = useAuth();

  const roleExistsInProfile = (rolesArray: Role[]) => user.roles.some((role) => rolesArray.includes(role));

  return { roleExistsInProfile };
};
